export const PHRASE_TRIGGER_DEFAULT_SIMILARITY_THRESHOLD = 0.7;
export const PHRASE_TRIGGER_SAMPLES_LIMIT = 1000;

export const INTERACTIONS_TAGGED_DATE_RANGE = 7;
